import { Icon } from '@dynamic/ui';
import { FC } from 'react';
import styled from 'styled-components';

import { tb } from '#/store/translation/translation.store';

import { focusShadow } from '../styles';

interface Props {
  onClick?: () => void;
}

export const CloseButton: FC<Props> = ({ onClick }) => (
  <StyledButton
    aria-label={tb('button.close')}
    data-testid="modal-closeButton"
    onClick={onClick}
    type="button"
  >
    <Icon aria-hidden="true" name="cross" />
  </StyledButton>
);

const StyledButton = styled.button`
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  height: 2rem;
  color: var(--pageParagraphForeground);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: background 0.1s ease-in-out;
  user-select: none;
  border: none;
  background: transparent;

  &:focus-visible {
    ${focusShadow}
  }

  :hover {
    background: rgb(255 255 255 / 10%);
  }

  :active {
    background: rgb(255 255 255 / 15%);
  }
`;
